import { LoadingSkeleton } from '@/components/SkeletonLoading';
import {
  Table,
  TableProps,
  TRecordType,
} from '@moneyforward/ap-frontend-components';
import classNames from 'classnames';
import styles from './BorderTable.module.scss';

const cx = classNames.bind(styles);

export const BorderTable = <RecordType extends TRecordType>(
  props: TableProps<RecordType>
) => {
  return (
    <div className={styles['border-table-container']}>
      {props.emptyType === 'loading' && !props.hideHeaderPagination && (
        <div className={styles['border-table-loading-pagination']}>
          <LoadingSkeleton />
        </div>
      )}
      <Table
        {...props}
        className={cx(
          styles['border-table'],
          styles['border-table-scroll'],
          props.emptyType === 'loading' && styles['border-table-loading']
        )}
      />
      {!props.hideFooterPagination && props.emptyType === 'loading' && (
        <div className={styles['border-table-loading-pagination']}>
          <LoadingSkeleton />
        </div>
      )}
    </div>
  );
};

BorderTable.displayName = 'BorderTable';
